"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));

var _styles = require("@material-ui/core/styles");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));

var _Button = _interopRequireDefault(require("../Button"));

var _ButtonGroup = _interopRequireDefault(require("../ButtonGroup"));

var _Theme = require("../Theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  padding-top: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  padding: ", ";\n  color: ", ";\n  font-size: 1.25rem;\n  font-weight: 500;\n  line-height: 1.2;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

// TODO: Material UI doesn't support overriding a theme locally by using the
// theme prop, like styled-components does. The theme argument in the
// withStyles function can only be updated using the MuiThemeProvider. The
// @material-ui/styles package (currently in alpha) is supposed to release
// with material-ui v4, and will support this functionality. Until then, we
// need these inline default values, to support a component having a default
// theme without requiring the consumer to use a ThemeProvider component in
// their app.
var Dialog = (0, _styles.withStyles)(function (theme) {
  return {
    paper: {
      margin: "".concat(theme.spacingXxl || '64px', " ").concat(theme.spacingL || '24px'),
      padding: theme.spacingL || '24px'
    }
  };
})(_Dialog.default);
var DialogContent = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      padding: '0',
      '& > *:first-child': {
        marginTop: 0
      },
      '& > *:last-child': {
        marginBottom: 0
      }
    }
  };
})(_DialogContent.default);

var Title = _styledComponents.default.h2(_templateObject(), function (props) {
  return props.hasContent ? "0 0 ".concat(props.theme.spacingL) : 0;
}, function (props) {
  return props.theme.colorTextPrimary;
});

var Actions = _styledComponents.default.div(_templateObject2(), function (props) {
  return props.theme.spacingL;
});

var Modal = /*#__PURE__*/function (_Component) {
  _inherits(Modal, _Component);

  function Modal(props) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Modal).call(this, props));
    _this.titleId = (0, _uniqueId.default)('hw-modal-title');
    return _this;
  }

  _createClass(Modal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          actions = _this$props.actions,
          children = _this$props.children,
          className = _this$props.className,
          maxWidth = _this$props.maxWidth,
          onClose = _this$props.onClose,
          _onExited = _this$props.onExited,
          open = _this$props.open,
          title = _this$props.title,
          theme = _this$props.theme,
          classes = _this$props.classes,
          fullWidth = _this$props.fullWidth,
          onEnter = _this$props.onEnter,
          onEntering = _this$props.onEntering,
          onExit = _this$props.onExit,
          onExiting = _this$props.onExiting,
          PaperProps = _this$props.PaperProps,
          scroll = _this$props.scroll,
          TransitionComponent = _this$props.TransitionComponent,
          transitionDuration = _this$props.transitionDuration,
          TransitionProps = _this$props.TransitionProps,
          showTitle = _this$props.showTitle,
          showActions = _this$props.showActions,
          otherProps = _objectWithoutProperties(_this$props, ["actions", "children", "className", "maxWidth", "onClose", "onExited", "open", "title", "theme", "classes", "fullWidth", "onEnter", "onEntering", "onExit", "onExiting", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps", "showTitle", "showActions"]);

      var hasContent = _react.default.Children.count(children) > 0;
      return _react.default.createElement(Dialog, _extends({}, otherProps, {
        "aria-labelledby": this.titleId,
        className: (0, _classnames.default)('hw-modal', className),
        open: open // this is because the Material dialog ONLY fires its native onClose with escape or overlay click, not any time the modal is closed
        ,
        onExited: function onExited() {
          onClose();
          _onExited && _onExited();
        },
        scroll: "paper",
        maxWidth: maxWidth
      }), showTitle && _react.default.createElement(Title, {
        id: this.titleId,
        className: "hw-modal-title",
        theme: theme,
        hasContent: hasContent
      }, title), children && _react.default.createElement(DialogContent, {
        className: "hw-modal-content"
      }, children), showActions && _react.default.createElement(Actions, {
        theme: theme
      }, _react.default.createElement(_ButtonGroup.default, {
        className: "hw-modal-actions"
      }, actions || _react.default.createElement(_Button.default, {
        color: "neutralLight",
        rounded: true,
        onClick: onClose
      }, "Close"))));
    }
  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  actions: _propTypes.default.any,
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  disableBackdropClick: _propTypes.default.bool,
  disableEscapeKeyDown: _propTypes.default.bool,
  fullScreen: _propTypes.default.bool,
  maxWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', false]),
  onBackdropClick: _propTypes.default.func,
  onClose: _propTypes.default.func,
  onEntered: _propTypes.default.func,
  onExited: _propTypes.default.func,
  onEscapeKeyDown: _propTypes.default.func,
  open: _propTypes.default.bool.isRequired,
  title: _propTypes.default.string.isRequired,
  showTitle: _propTypes.default.bool,
  showActions: _propTypes.default.bool,
  // TODO: update this propType with all the variables being used in the modal
  // once @material-ui/styles package is being used.
  theme: _propTypes.default.shape({
    colorTextPrimary: _propTypes.default.string,
    spacingL: _propTypes.default.string
  })
};
Modal.defaultProps = {
  disableBackdropClick: false,
  disableEscapeKeyDown: false,
  fullScreen: false,
  maxWidth: 'sm',
  onClose: function onClose() {},
  theme: _Theme.defaultTheme,
  showTitle: true,
  showActions: true
};

var _default = (0, _styledComponents.withTheme)(Modal);

exports.default = _default;


// WEBPACK FOOTER //
// /src/~/@healthwise-ui/core/Modal/index.js